// extracted by mini-css-extract-plugin
export default {"dialog":"style--dialog--5aa157","reviewPanel":"style--reviewPanel--d383bd"};